var map = {
	"./1.jpg": 2625,
	"./DataNotFound.svg": 2758,
	"./Group 2459.svg": 835,
	"./SSHE-logo(old).svg": 5826,
	"./SSHE-logo-mini(old).svg": 2913,
	"./SSHE-logo-mini.svg": 5694,
	"./SSHE-logo.svg": 5838,
	"./Search.png": 9395,
	"./Union 14.svg": 4979,
	"./WarningMessage.svg": 8603,
	"./body.png": 4071,
	"./broken.png": 7227,
	"./calendar.png": 3611,
	"./file.png": 7408,
	"./folder.png": 5720,
	"./github-icon.svg": 1643,
	"./icons - Shortcut.lnk": 198,
	"./ill-approve.png": 1511,
	"./ill-approve4x.png": 767,
	"./image.png": 8593,
	"./law4x.png": 1170,
	"./legal.png": 5454,
	"./linkedin-icon.svg": 9324,
	"./list-ill.png": 2689,
	"./list.png": 7124,
	"./manage-role.png": 7198,
	"./mentor.png": 8951,
	"./mentor4x.png": 5181,
	"./message-lines.png": 2022,
	"./money-sack.png": 2754,
	"./near-miss.png": 7488,
	"./next.png": 1946,
	"./occupational-health-and-safety.png": 3150,
	"./pankod-icon.svg": 5968,
	"./patient.png": 4614,
	"./profile-icon.jpg": 5479,
	"./report4x.png": 3287,
	"./right-arrow.png": 2384,
	"./role4x.png": 5444,
	"./shee-text.svg": 4189,
	"./sidebar-bg.png": 2691,
	"./twitter-icon.svg": 4880,
	"./youtube-icon.svg": 2895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;